<template>
  <div class="studio-summary">
    <div class="summary" v-for="col in widget.columns" :key="col.id">
      <!-- title -->
      <div class="summary-title">{{ col.name }}</div>
      <!-- count -->
      <div class="summary-count" :ref="col.fieldName">
        <span v-if="col.id === 'storageUsed' && viewData && viewData[col.fieldName]">
          {{humanFileSize(viewData[col.fieldName])}}</span>
        <span v-else>{{ (viewData && viewData[col.fieldName]) || "-" }}</span>
      </div>
      <!-- action -->
      <template v-if="!loading">
        <!-- user manage -->
        <fts-btn
          sm
          outline
          color="primary"
          text-transform-init
          box-shadow-none
          class="summary-btn"
          @click="manageUser"
          v-if="col.id === 'currentUsers'"
        >
          Manage
        </fts-btn>
        <!-- credit subscribe -->
        <fts-btn
          sm
          outline
          color="primary"
          text-transform-init
          box-shadow-none
          class="summary-btn"
          @click="creditSubscribe"
          v-if="col.id === 'creditUsedToday'"
        >
          Subscribe
        </fts-btn>
        <!-- storage subscribe -->
        <fts-btn
          sm
          outline
          color="primary"
          text-transform-init
          box-shadow-none
          class="summary-btn"
          @click="storageSubscribe"
          v-if="col.id === 'storageUsed'"
        >
          Subscribe
        </fts-btn>
      </template>
    </div>
    <!-- workspace modal -->
    <fts-workspace-modal ref="ftsWorkspaceModal" />
  </div>
</template>

<script>
import { store as canvasDesignStore } from "../../store/canvasDesignStore";

import FTSBtn from "../../elements/FTSBtn";
import FTSWorkspaceModal from "../../design/FTSWorkspaceModal";
import { settingsStageAllowed } from "../../settings/settingsStage";

export default {
  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
    viewData: {
      type: Object,
      default: () => ({}),
    },
    loading: Boolean,
  },
  components: {
    "fts-btn": FTSBtn,
    "fts-workspace-modal": FTSWorkspaceModal,
  },
  data: () => ({
    test: 0,
  }),
  methods: {
    humanFileSize(bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }

      const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
      );

      return bytes.toFixed(dp) + " " + units[u];
    },
    manageUser() {
      window.open("/#/users", "_blank");
    },
    creditSubscribe() {
      this.openBilling("credits");
    },
    storageSubscribe() {
      this.openBilling("plan");
    },
    /**
     * Inside the settings stage, the settings page for it (storage is part of the plan);
     * everyone else keeps the dialog's Plan & Credits tab (W-25).
     */
    openBilling(section) {
      if (settingsStageAllowed()) {
        this.$router.push({ name: "settings", params: { section } }).catch(() => {});
        return;
      }
      this.$refs.ftsWorkspaceModal.show({
        id: this.workspaceId,
        section: "subscription",
      });
    },
  },
  computed: {
    workspaceId() {
      return canvasDesignStore.getters.workspaceId;
    }
  }
};
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;

.studio-summary {
  color: var(--fts-text);
  .summary {
    &:not(:last-child) {
      margin-bottom: 1rem;
      .summary-btn {
        margin-bottom: 0.375rem;
      }
    }
    &:not(:first-child) {
      border-top: 1px solid var(--fts-border);
      .summary-title {
        margin-top: 1.575rem;
      }
    }
    .summary-title {
      @include text-overflow-ellipsis;
      margin-bottom: 0.575rem;
    }
    .summary-count {
      padding: 0 1rem;
      font-size: 2.5rem;
      font-weight: 600;
      line-height: 1.5;
    }
    .summary-btn {
      margin-top: 0.575rem;
    }
  }
}
</style>